var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7626 8.36792H17.1249V8.33334H9.99992V11.6667H14.474C13.8213 13.6071 12.0674 15 9.99992 15C7.37673 15 5.24992 12.7613 5.24992 10C5.24992 7.23876 7.37673 5.00001 9.99992 5.00001C11.2108 5.00001 12.3124 5.48084 13.1511 6.26625L15.3904 3.90917C13.9765 2.52209 12.0852 1.66667 9.99992 1.66667C5.62794 1.66667 2.08325 5.39792 2.08325 10C2.08325 14.6021 5.62794 18.3333 9.99992 18.3333C14.3719 18.3333 17.9166 14.6021 17.9166 10C17.9166 9.44126 17.862 8.89584 17.7626 8.36792Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99609 6.12125L5.59711 8.12917C6.30091 6.29501 8.00536 5.00001 9.99997 5.00001C11.2108 5.00001 12.3124 5.48084 13.1512 6.26625L15.3904 3.90917C13.9765 2.52209 12.0852 1.66667 9.99997 1.66667C6.95918 1.66667 4.32214 3.47376 2.99609 6.12125Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 18.3333C12.0448 18.3333 13.9029 17.5096 15.3077 16.17L12.8575 13.9875C12.0359 14.6452 11.0321 15.0009 9.99996 15C7.94084 15 6.19244 13.6179 5.53377 11.6892L2.95215 13.7829C4.26236 16.4817 6.92315 18.3333 9.99996 18.3333Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7627 8.36791H17.125V8.33333H10V11.6667H14.4741C14.1619 12.5902 13.5995 13.3972 12.8563 13.9879L12.8575 13.9871L15.3077 16.1696C15.1344 16.3354 17.9167 14.1667 17.9167 9.99999C17.9167 9.44124 17.862 8.89583 17.7627 8.36791Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.5dc3f5df8220b494fb5c6a83f468cdc3.svg";
export { ForwardRef as ReactComponent };